import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tuition-fee',
  templateUrl: './tuition-fee.component.html',
  styleUrls: ['./tuition-fee.component.scss']
})
export class TuitionFeeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
